import React, { useEffect, useRef, useState } from "react";
import { ChevronDown, LogOut } from "lucide-react";
import { useNavigate } from "react-router-dom";
import "../../styles/admin/admin-header.css";

export default function AdminHeader() {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const [adminName, setAdminName] = useState("Usuario");
  const [adminRole] = useState("Administrador");
  const menuRef = useRef(null);

  useEffect(() => {
    const storedUser = localStorage.getItem("petfamUser");

    if (storedUser) {
      try {
        const parsedUser = JSON.parse(storedUser);

        const fullName = `${parsedUser?.name || ""} ${parsedUser?.lastName || ""}`.trim();

        if (fullName) {
          setAdminName(fullName);
        }
      } catch (error) {
        console.error("No se pudo leer petfamUser del localStorage:", error);
      }
    }
  }, []);

  useEffect(() => {
    function handleClickOutside(event) {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setMenuOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleBackToUser = () => {
    setMenuOpen(false);
    navigate("/interfaz");
  };

  return (
    <header className="admin-header">
      <div className="admin-header-left">
        <div>
          <h1>Panel de administración</h1>
          <p>Gestiona usuarios, mascotas y aliados de Petfam</p>
        </div>
      </div>

      <div className="admin-header-right">
        <div className="admin-user-menu-wrapper" ref={menuRef}>
          <button
            type="button"
            className={`admin-user-pill ${menuOpen ? "open" : ""}`}
            onClick={() => setMenuOpen((prev) => !prev)}
          >
            <div className="admin-user-avatar">
              {adminName?.charAt(0)?.toUpperCase() || "U"}
            </div>

            <div className="admin-user-info">
              <strong>{adminName}</strong>
              <span>{adminRole}</span>
            </div>

            <ChevronDown
              size={18}
              className={`admin-chevron ${menuOpen ? "rotated" : ""}`}
            />
          </button>

          {menuOpen && (
            <div className="admin-user-dropdown">
              <button type="button" onClick={handleBackToUser}>
                <LogOut size={16} />
                <span>Salir</span>
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
}